<template>
  <v-card flat>
    <v-card-title>Bokning</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="items"
            item-value="code"
            item-text="_text"
            outlined
            label="Bokningar"
            item-disabled="hidden"
            v-model="model.bookings"
            multiple
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click:close="remove(data.item)"
              >
                {{ data.item._text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'DuwaBookings',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    model: {
      bookings: []
    }
  }),

  created() {
    this.model.bookings = this.currentBookings
  },

  watch: {
    'model.bookings'(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          booking: {
            ...x.booking,
            after: value.map(code => ({ code }))
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    currentBookings: get('duwa/currentBookings'),
    items() {
      return this.codes
        .filter(x => x.category === 'booking')
        .map(x => {
          if (x.text_43_characters) {
            x._text = x.text_43_characters
          } else if (x.text_13_characters) {
            x._text = x.text_13_characters
          } else if (x.text_9_characters) {
            x._text = x.text_9_characters
          }

          return x
        })
        .filter(
          x => !x.hidden || this.currentBookings.some(code => code === x.code)
        )
    }
  },

  methods: {
    remove(item) {
      const index = this.model.bookings.indexOf(item.code)
      if (index >= 0) this.model.bookings.splice(index, 1)
    }
  }
}
</script>
